import { KinematicBodyFacet } from 'engine/facets/KinematicBodyFacet';
import { newV2, scaleV2 } from 'engine/lib/V2';
import { MoveToModule, ProcessPayload } from 'game/state/BotState';
import { Processor } from '../Processor';

export const moveToProcessor: Processor<MoveToModule> = (module, ctx) => {
  const body = ctx.bot.entity.getFacet(KinematicBodyFacet);
  if (!body) return { status: 'null' };

  const payload: ProcessPayload = {
    type: 'command',
    action: 'move',
    target: module.config.target,
  };

  const [x1, y1] = ctx.bot.entity.transform.position;
  const [x2, y2] = module.config.target;

  if (Math.abs(y2 - y1) <= 3 && Math.abs(x2 - x1) <= 3) {
    return { status: 'success', moduleId: module.id, value: payload };
  }

  const angle = Math.atan2(y2 - y1, x2 - x1);
  const v = newV2(Math.cos(angle), Math.sin(angle));
  const { botSpeed } = ctx.bot.props.state;
  body.move(scaleV2(v, botSpeed * ctx.delta), ctx.engine);

  return { status: 'running', value: payload };
};
